export default "__VITE_ASSET__CAwz9gZi__"